import { render, staticRenderFns } from "./course-form.vue?vue&type=template&id=86d7d282&"
import script from "./course-form.vue?vue&type=script&lang=js&"
export * from "./course-form.vue?vue&type=script&lang=js&"
import style0 from "./course-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "course-form.vue"
export default component.exports